import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormInputsProps } from '../types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Input } from 'src/components/Inputs/Input';
import { getValidationRules } from 'src/utils/validations/getValidationRules';

export const FormInput: FC<FormInputsProps> = ({ field, defaultValue }) => {
  const { t } = useTranslation();
  const { name, title, toShow } = field;
  const {
    register,
    formState: { errors }
  } = useFormContext();

  const isDialingCodeInput = name === 'dialingCode';
  const isNationalityInput = name === 'nationality';
  const isShowField = toShow && !defaultValue;
  const { validationRules = {}, maxLength = 300 } = getValidationRules(name);

  if (isDialingCodeInput) return;

  return (
    <Input
      {...register(name, {
        required: { value: toShow, message: 'validation.valueRequired' },
        ...validationRules
      })}
      inputWrapperProps={{
        className: classNames(!isShowField && 'hidden')
      }}
      className={isNationalityInput ? 'uppercase placeholder:normal-case' : ''}
      defaultValue={defaultValue}
      placeholder={title}
      label={title}
      id={name}
      type="text"
      errorMessage={errors[name] && `${t(errors[name]?.message as string)}`}
      maxLength={maxLength + 1}
    />
  );
};
